import React from 'react';
import './CourseCheckboxes.css';

const CourseCheckboxes = ({ courses, selectedItems, handleItemChange, selectedItemMax }) => {
  const maxSelectionsReached = selectedItems.length >= selectedItemMax;

  return (
    <div className="form-control course-checkboxes">
      {courses.map((courseObj, index) => {
        const courseName = courseObj.courseName;
        const isChecked = selectedItems.includes(courseObj._id);
        const isDisabled = !isChecked && maxSelectionsReached && selectedItemMax > 1; // Disabilita se non è selezionato e si è raggiunto il massimo

        return (
          <label key={index}>
            <input
              type="checkbox"
              value={courseObj._id}
              checked={isChecked}
              onChange={() => handleItemChange(courseObj._id)}
              disabled={isDisabled}
            />
            {courseName}
          </label>
        ); 
      })}
      
      {/* <label>
        <input
          type="checkbox"
          value=""
          checked={!selectedItems.length}
          onChange={() => handleItemChange(null)}
        />
        SCEGLIERÒ ENTRO LA FINE DELL'ORIENTAMENTO
      </label> */}

    </div>
  );
};

export default CourseCheckboxes;